import { render, staticRenderFns } from "./BajaProductos.vue?vue&type=template&id=5302f7ea"
import script from "./BajaProductos.vue?vue&type=script&lang=js"
export * from "./BajaProductos.vue?vue&type=script&lang=js"
import style0 from "./BajaProductos.vue?vue&type=style&index=0&id=5302f7ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports